import { PercentPipe } from "@angular/common";
import { Component, effect, inject, signal } from "@angular/core";
import { toObservable, toSignal } from "@angular/core/rxjs-interop";
import { ThousandizePipe } from "ev-core";
import { EvLogoLoaderComponent } from "src/app/shared-components/ev-logo-loader/ev-logo-loader.component";
import { combineLatest, map } from "rxjs";
import { InhabitantDemographicsModel } from "src/models/map/demographic-area-data";
import { DemographyDataService, VisibleSection } from "src/services/estate/demography-data.service";

@Component({
    selector: "inhabitant-demography",
    imports: [EvLogoLoaderComponent, ThousandizePipe, PercentPipe],
    templateUrl: "./inhabitant-demography.component.html",
    styleUrl: "./inhabitant-demography.component.scss",
})
export class InhabitantDemographyComponent {
    demographicsDataService = inject(DemographyDataService);

    showAll = signal(false);
    minEntriesToShow = 5;
    totalEntries = 0;
    warningTextTooltipShow = false;
    showMoreInfo = false;
    visibleSection = VisibleSection;

    inhabitantDemographicsData: InhabitantDemographicsModel[] = [];

    constructor() {
        effect(() => {
            if (this.demographicsDataService.inhabitantDemographicIsLoading()) {
                this.inhabitantDemographicsData = [];
            }

            if (this.demographicsDataService.inhabitantDemographicResource.hasValue()) {
                this.inhabitantDemographicsData = this.demographicsDataService.inhabitantDemographicResource.value();

                this.totalEntries = this.inhabitantDemographicsData.filter((x) => x.shouldShow).length;
                let showAll = false;
                if (this.totalEntries - 1 <= this.minEntriesToShow) showAll = true;
                this.showAll.set(showAll);
            }
        });
    }

    inhabitantDemographics = toSignal(
        combineLatest([toObservable(this.demographicsDataService.inhabitantDemographicResource.value), toObservable(this.showAll)]).pipe(
            map(([dem, showAll]) => {
                if (dem != null && dem.length > 1) {
                    const sliceSize = showAll ? this.totalEntries : this.minEntriesToShow;
                    const res = dem
                        .slice(1)
                        .filter((x: any) => x.shouldShow)
                        .slice(0, sliceSize);
                    return res;
                }
                return [];
            }),
        ),
    );

    inhabitantDemographicsTotal = toSignal(
        combineLatest([
            toObservable(this.demographicsDataService.inhabitantDemographicResource.value),
            toObservable(this.demographicsDataService.inhabitantDemographicIsLoading),
        ]).pipe(
            map(([dem, isLoading]) => {
                if (isLoading) {
                    return [];
                } else {
                    return dem != null && dem.length > 0 ? dem[0] : ({ shouldShow: false } as InhabitantDemographicsModel);
                }
            }),
        ),
    );

    showAllEntries(): void {
        this.showAll.set(true);
    }
}
